import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import productOne from "../../assets/img/health.png";
import productTwo from "../../assets/img/health1.png";
import productThree from "../../assets/img/health3.png";
// import productFour from "../../assets/img/spicesProduct.webp";
import productFive from "../../assets/img/health2.png";
// import ProductSix from "../../assets/img/cultivation.jpg";
// import productSeven from "../../assets/img/foodProduct.jpg"
// import product from "../../assets/img/herbalProduct.webp";

const titleStyles = {
  fontSize: ".9em",
 
};

export default function ProductLayout() {
  const productData = [
    {
      path: "/herbalProduct",
      img: productOne,
      title: "Healthy Mix",
    },
    {
      path: "/gardenProduct",
      img: productTwo,
      title: " Weight Loss",
    },

    {
      path: "/yogaProduct",
      img: productFive,
      title: "Weight Gain",
    },
    // {
    //   path: "/spices",
    //   img: ProductSix,
    //   title: "soap stone",
    // },
    // {
    //   path: "/combo",
    //   img: productSeven,
    //   title: "Combo offers",
    // },
    // {
    //   path: "/bakery",
    //   img: productFour,
    //   title: "Bakery mould items",
    // },
    // {
    //   path: "/unique",
    //   img: product,
    //   title: "Unique items",
    // },
    {
      path: "/foodProduct",
      img: productThree,
      title: "Others",
    },
  ];

  return (
    <>
      {productData.map((data, index) => {
        return (
          <Col
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={3}
            className="mb-4"
            key={index + "product"}
          >
            <div className="card h-100 d-flex flex-column">
              <Link to={data.path} className="d-block">
                <img
                  src={data.img}
                  className="card-img-top"
                  alt="jannu's Food Products"
                  style={{
                    height: "300px",
                    width: "100%",
                    // objectFit: "cover",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                  }}
                />
              </Link>
              <div
                className="card-body d-flex justify-content-center align-items-center"
                style={{ boxShadow: "1px 1px 20px rgba(183, 180, 180, 0.5)" }}
              >
                <Link
                  to={data.path}
                  className="h6 text-decoration-none text-uppercase text-dark text-center productTitle"
                  style={titleStyles}
                >
                  {data.title}
                </Link>
              </div>
            </div>
          </Col>
        );
      })}
    </>
  );
}